var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSlots24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_slots24x24",
    transform: "translate(-4.093 -2.071)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    d: "M16.247,14a3.788,3.788,0,0,0-1.74.458,1.916,1.916,0,0,0-.55.366s-.366-.092-.824-.183h-.55a1.559,1.559,0,0,0-.641.092c-.092,0-.183.092-.366.092-.092,0-.183.092-.275.092-.733.458-1.282,1.282-1.007,3.114a2.7,2.7,0,0,0,.458,1.191c.092.092.092.183.183.275s.092.183.183.275a4,4,0,0,0,3.3,1.74,1.559,1.559,0,0,0,.641-.092,4.088,4.088,0,0,0,3.389-4.763C18.17,14.55,17.162,14,16.247,14Z",
    transform: "translate(-.214 -1.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    d: "M19.054,6.115,18.68,4.954a.358.358,0,0,0-.467-.268c-.093,0-.093,0-.093.089l-1.028.446A6.721,6.721,0,0,0,14.381,2.9c-2.056-1.071-4.206-.893-4.393-.625s.935,2.054,2.991,3.036a4.744,4.744,0,0,0,1.589.536C11.483,7.008,9.521,9.776,8.4,12.276c0,.089-.093.179-.093.268s-.093.179-.093.268a3.946,3.946,0,0,0-1.682-.446c-.935,0-2.056.446-2.337,2.411A3.394,3.394,0,0,0,6.9,18.883H7.09a1.659,1.659,0,0,0,.654.089A4.146,4.146,0,0,0,9.8,18.436a5.5,5.5,0,0,1-.561-1.607,3.819,3.819,0,0,1,.654-3.3l.467-.446a1.8,1.8,0,0,0-.654-.179c.093-.089.093-.179.187-.268s.093-.179.187-.268A11.781,11.781,0,0,1,13.82,7.9c-.093.089-.093.179-.187.357a7.005,7.005,0,0,0-.561,4.375c.374,0,.561.089.748.089a1.965,1.965,0,0,0,.561-.357A7,7,0,0,1,14.848,8.7,4.3,4.3,0,0,1,17.091,6.74l1.869-.179C19.054,6.561,19.148,6.293,19.054,6.115Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSlots24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_slots24x24.03385206f15e05320334ca06fde21ed6.svg";